// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionDurationMaybe_root__3wB32","title":"SectionDurationMaybe_title__12F1R","listingPageSectionContent":"SectionDurationMaybe_listingPageSectionContent__1cRLW"};